<div class="btn {{btnClass}} rounded-circle position-relative background-pure-white width-40px height-40px {{disabled ? 'disabled' : ''}}">
    @if (loading) {
        <div>
            <app-spinner [loading]="loading"
                        class="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"></app-spinner>
        </div>
    } @else {
        <div
            class="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
            style="z-index: 1;">
            <i class=" {{ icon }}"></i>
        </div>
    }
</div>